<template>
  <div class="busRoute">
    <div class="busRoute__header1">
      <button class="btn-large primary" @click="addNew">Add New Route</button>
    </div>
    <div class="busRoute__header2">
      <div class="busRoute__header2__search">
        <i class="adx-ic_search"></i>
        <input v-model="searchBoxValue" type="text" placeholder="Search">
      </div>
      <div class="busRoute__header2__sort">
        <p>Sort by :</p>
        <div>
          <a-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sortOptions"></a-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="busRoute__listing">
      <div  class="tableWrapper">
      <table>
        <thead>
          <tr>
            <td class="col1">Route</td>
            <td class="col2">Placement</td>
            <td class="col2">Owner</td>
            <td class="col3"></td>
          </tr>
        </thead>

        <tbody v-if="!isLoading">
          <tr v-for="(route, index) in routes" :key="index" class="content">
            <td class="col1">
              <div class="routeGroup">
                <div class="subhead route name">{{route.name}}</div>
                <div class="small-font detail">{{route.detail}}</div>
              </div>
            </td>
            <td v-if="route.placements.length === 0" class="col2"><span>-</span></td>
            <td v-else-if="route.placements.length > 0 && route.placements.length <= 1" class="col2">
              <div v-for="(placement, index) in route.placements" :key="index" class="subhead elipsis">
                {{placement}}
              </div>
            </td>
            <td v-else-if="route.placements.length > 1" class="col2">
              <div :class="[show[index] ? '': 'hidden']">
                <div v-for="(placement, index) in route.placements" :key="index" class="subhead elipsis">
                  {{placement}}
                </div>
              </div>
              <div v-if="!show[index]" class="showButton" @click="showMore(index)">
                <span class="small-font toggleShow" >Show More</span>
                <i class="icon-chevrondown"></i>
              </div>
              <div v-else class="showButton" @click="showMore(index)">
                <span class="small-font toggleShow" >Show Less</span>
                <i class="icon-chevronup"></i>
              </div>
            </td>
            <td class="col2"><span class="subhead owner">{{route.owner}}</span></td>
            <td class="col3">
              <a-menu-expansion :lists="route.delete? menuActions: menuActionsNot" @selected="selected($event, route)"/>
            </td>
          </tr>
        </tbody>
      </table>
      </div>

      <div class="emptyState">
        <a-empty-selection v-if="isEmpty && !isLoading" :title="title"/>
      </div>
      <div v-if="isLoading" class="table__loadingWrapper">
        <slot name="loading" />
        <a-loading/>
      </div>
      <div class="pagination" v-if="!isLoading && !isEmpty">
        <div class="total" >{{getDataRange}} of {{count}} Routes</div>
        <a-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage"/>
      </div>
    </div>
    <a-modal hideClose="true" v-if="isShowModal" title="Delete Route" type="small">
      <div slot="content" class="busRoute__modal">
        <div class="busRoute__modal__top">
          <span>Sure want to delete this route?</span>
        </div>
        <div class="busRoute__modal__bottom">
          <button class="btn-regular primary" @click="deleteRoute">Yes<a-loading-2 class="btn-loading" v-if="isLoadingMutation"/></button>
          <button class="btn-regular primary" @click="cancelDelete">Cancel</button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import MenuExpansion from '@/components/MenuExpansion'

import * as validationLib from '@/lib/validation/'
import { mapGetters } from 'vuex'
import { parseErrorGql } from '@/lib/error'
import { restEdge } from '@/api/edgeUrls'
import { globalMixins } from '@/lib/mixins/globalMixins'
import api from '@/api'
import { 
  ALoadingPrimary, ALoadingSecondary, ALoadingSecondaryWhite, AEmptySelection, AModal,
  ASelectDropdown, APagination, AMenuExpansion 
} from "ui-kit-v1"

const {
  helpers,
} = validationLib;

export default {
  name: 'adx-bus-route',
  components: {
    'a-modal': AModal,
    'a-empty-selection': AEmptySelection,
    'a-loading': ALoadingPrimary,
    'a-loading-2': ALoadingSecondaryWhite,
    'a-dropdown-sort': ASelectDropdown,
    'a-pagination': APagination,
    'a-menu-expansion': AMenuExpansion,
  },
  mixins: [ globalMixins ],
  props: {

  },
  data() {
    return {
      title: "You dont have any Route here. lets create some !",
      isShowModal: false,
      selectedRouteId: null,
      show: [],
      selectedPage: 1,
      maxPage: 1,
      selectedSortValue: "last_added",
      searchBoxValue: null,
      isLoadingMain:false,
      isLoadingMutation: false,
      isEmpty: false,
      count: 0,
      countDuplicate: 0,
      countDelete: 0,
      sortOptions: [
        {
          label: "Last Added",
          value: "last_added",
        },
        {
          label: "First Added",
          value: "first_added",
        },
        {
          label: "Name",
          value: "name",
        }
      ],
      menuActionsList: [],
      menuActions: [
        {
          'id': 0,
          'name': ' Edit Route',
          'value': 'editroute',
        },
        {
          'id': 1,
          'name': ' Duplicate Route',
          'value': 'duplicateroute'
        },
        {
          'id': 2,
          'name': 'Delete Route',
          'value': 'deleteroute'
        }
      ],
      menuActionsNot: [
        {
          'id': 0,
          'name': ' Edit Route',
          'value': 'editroute',
        },
        {
          'id': 1,
          'name': ' Duplicate Route',
          'value': 'duplicateroute'
        },
        {
          'id': 2,
          'name': 'Delete Route',
          'value': 'deleteroute',
          'disabled': 'You must deactivate and unpublish this item first, before delete.',
          'position': 'top'
        }
      ],
      routes: []
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    isLoading: function(){
      return this.isLoadingMain || this.isLoadingMutation || false
    },
    getDataRange: function(){
      let endPage = this.selectedPage * 15;
      return this.count > 15 ? ((endPage < this.count) ? endPage: endPage - 15 + (this.count % 15)) : this.count
    },
    getQueryParams(){
      let queryParams = {
        search: this.searchBoxValue != null ? this.searchBoxValue.toString() : undefined,
      }
      return queryParams
    }
  },
  apollo: {

  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.selectedPage = 1;
      this.count = 0;
      this.getRoutes()
    }, 500),
    selectedSortValue: function () {
      this.selectedPage = 1;
      this.count = 0;
      this.getRoutes()
    },
    selectedPage: function (){
      this.count = 0;
      this.getRoutes()
    }
  },
  beforeCreate() {

  },
  created() {
    localStorage.setItem('apollo-token', this.token);
    this.getRoutes();
    this.createShowArray()
  },
  beforeMount() {

  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async getRoutes(){
      this.isLoadingMain = true;
      const response = await api.get(restEdge.busRoutes, { needToken: true, useRestEdge: true, params:{page:this.selectedPage, ...this.getQueryParams, sort: this.selectedSortValue}});
      if(response.status == 200){
        const {data} = response
        let tmpRoutes = []
        data.results.map( route => {
          tmpRoutes.push({
            id: route.id,
            name: route.title,
            detail: this.processedDetail(route.routeDetails, route.category),
            placements: this.processedPlacement(route.buses),
            owner: route.owner.email || "user@gmail.com",
            delete: route.buses.length == 0
          })
        });
        this.routes = await tmpRoutes;
        this.maxPage = data.maxPage;
        this.count = data.count;
        this.isEmpty = this.routes.length === 0;
        this.isLoadingMain = false;
      } else {
        this.showNotificationAlert('Error', 'Ops, something went wrong.', 'danger')
      }
    },
    addNew() {
      this.$router.push({name: 'addnewroute'})
    },
    selected(event, item){
      if(event.value ===  'editroute'){
        this.$router.push({name: 'editroute',  params: {  id: item.id }})
      } else if(event.value ===  'duplicateroute'){
        this.duplicateRoute(item.id)
      } else if(event.value ===  'deleteroute' && !event.hasOwnProperty('disabled')){
        this.confirmDelete(item.id)
      }
    },
    async duplicateRoute(id) {
      this.isLoadingMutation = true;
      const response = await api.post(restEdge.duplicateRoute(id), {}, { needToken: true, useRestEdge: true,});

      if (response.status == 200) {
        this.getRoutes();
        this.isLoadingMutation = false;
        this.showNotificationAlert('Success', 'Data successfully duplicated!', 'success')
      } else {
        this.isLoadingMutation = false;
        this.showNotificationAlert('Error', 'Data failed to duplicate!', 'danger')
      }

    },
    async deleteRoute() {
      this.isLoadingMutation = true;
      const response = await api.destroy(restEdge.deleteRoute(this.selectedRouteId), { needToken: true, useRestEdge: true,});
      if(response.status == 200) {
        this.toggleModal();
        this.getRoutes();
        this.isLoadingMutation = false;
        this.showNotificationAlert('Success', 'Data successfully deleted!', 'success')
      } else {
        this.toggleModal();
        this.getRoutes();
        this.isLoadingMutation = false;
        this.showNotificationAlert('Error', 'Data failed to delete!', 'danger')
      }
    },
    confirmDelete(id){
      this.selectedRouteId = id;
      this.toggleModal()
    },
    cancelDelete(){
      this.selectedRouteId = null;
      this.toggleModal()
    },
    toggleModal(){
      this.isShowModal = !this.isShowModal
    },
    showMore(index) {
      // assign array this way to make array change on DOM.
      this.$set(this.show, index, !this.show[index]);
    },
    selectPage(page) {
      this.selectedPage = page;
      this.count = 0;
      this.getRoutes()
    },
    processedDetail(array, category) {
      let processed = [];
      if (array){
        array.map(index => {
          processed.push(index.location)
        })
      }
      let processed_mid=[];
      if (processed.length > 3){
        let len = Math.round(processed.length/2);
        processed_mid.push(processed[len-1]);
        processed_mid.push(processed[len]);
        processed_mid.push(processed[len+1])
      } else {
        processed_mid = processed
      }
      let final_process = processed_mid.join(' - ');
      let cat = category? category.title : "";
      return '('+ cat+ ') Via ' + final_process
    },
    processedPlacement(bus) {
      let processed = [];
      if (bus){
        bus.map(index => {
          processed.push(index.generic.title)
        })
      }
      return processed
    },
    createShowArray() {
      let i = 0;
      for (i = 0; i < this.routes.length; i++) {
        this.show.push(false)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">

.busRoute {
  &__listing {
    .tableWrapper {
      table {
        tbody {
          tr {
            td {
              .menuexpansion {
                .tooltiptext {
                  right: auto;
                  min-width: 165px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>